export type ContactCategory = 'general' | 'spam' | 'vip';

export const CONTACT_CATEGORY_VALUES: Record<ContactCategory, number> = {
  general: 0,
  spam: 1,
  vip: 2
};

export interface AssociatedRecord {
  id: number;
  first_name: string | null;
  last_name: string | null;
}

export interface ContactResponse {
  id: number;
  phone_number: string | null;
  first_name: string | null;
  last_name: string | null;
  category: ContactCategory;
  do_not_call: boolean;
  location_id: number;
  business_id: number | null;
  created_at: string;
  updated_by_name: string | null;
  associated_records: AssociatedRecord[];
  chats_count: number;
  calls_count: number;
  latest_interaction_id: number | null;
  latest_interaction_agent_id: number | null;
  latest_interaction_at: string | null;
  meta?: null;
  call?: any;
}

export interface ContactRequest {
  contact: {
    phone_number?: string;
    category?: ContactCategory;
    do_not_call?: boolean;
  };
}

export interface NotesResponse {
  id: number;
  description: string;
  created_at: string;
  created_by: string;
}

export interface NoteRequest {
  note: {
    description: string;
  };
}
